import {
  MaxEnkaNatoriumuQuantity,
  MaxEnsuiQuantity,
} from '@/models/johaisetsu/johaisetsuCommon';

export interface StockHistory {
  ts: string;
  enka_natoriumu_quantity: number;
  enka_natoriumu_quantity_diff: number;
  ensui_quantity: number;
  ensui_quantity_diff: number;
}

export interface StockInfo {
  as_of: string;
  enka_natoriumu_quantity: number;
  ensui_quantity: number;
}
export interface EnsuiPlant {
  id: number;
  name: string;
  group_name: string;
  // DBカラムはNULL許容（未設定の場合はnull）
  max_enka_natoriumu_quantity: number | null;
  max_enka_natoriumu_quantity_disp: string;
  // DBカラムはNULL許容（未設定の場合はnull）
  max_ensui_quantity: number | null;
  max_ensui_quantity_disp: string;
  lat: string;
  lon: string;
  disp_order: number;
  stock_histories: StockHistory[];
  stock_info: StockInfo;
}

export interface UpdateMaxEnkaNatoriumuQuantityResponse {
  max_enka_natoriumu_quantity: number | null;
  max_enka_natoriumu_quantity_disp: string;
}

export const toMaxEnkaNatoriumuQuantity = (
  res: UpdateMaxEnkaNatoriumuQuantityResponse,
): MaxEnkaNatoriumuQuantity => ({
  maxEnkaNatoriumuQuantity: res.max_enka_natoriumu_quantity,
  maxEnkaNatoriumuQuantityDisp: res.max_enka_natoriumu_quantity_disp,
});

export interface UpdateMaxEnsuiQuantityResponse {
  max_ensui_quantity: number | null;
  max_ensui_quantity_disp: string;
}

export const toMaxEnsuiQuantity = (
  res: UpdateMaxEnsuiQuantityResponse,
): MaxEnsuiQuantity => ({
  maxEnsuiQuantity: res.max_ensui_quantity,
  maxEnsuiQuantityDisp: res.max_ensui_quantity_disp,
});
